import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { fetchAuthorAuditLogHistory } from 'src/api/queries';
import { Box, Flex, Text } from '@chakra-ui/react';
import TimelineStep from './TimelineStep';
import { ButtonText, Pagination } from '@morressier/alembic';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleDoubleDown,
  faAngleDoubleUp
} from '@fortawesome/pro-regular-svg-icons';
import Loading from 'src/pages/Status/Loading';
import { NoRecordFound } from 'src/pages/ReviewList/EmptyState';

const LIMIT = 10;
interface IAuditLogProps {
  userId: string;
}

const AuditLog = ({ userId }: IAuditLogProps) => {
  const [page, setPage] = useState<number>(1);
  const offset = (page - 1) * LIMIT;
  const { data: auditLogData, isLoading } = useQuery({
    queryKey: ['aduit-log', { page, userId }],
    queryFn: () => fetchAuthorAuditLogHistory(userId, LIMIT, offset),
    enabled: true
  });
  const [expanded, setExpanded] = useState<number[]>([0]);
  const totalPages = Math.ceil((auditLogData?.total || 0) / LIMIT);
  const toggleStep = (index: number) => {
    setExpanded(prev =>
      prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]
    );
  };
  const results = auditLogData?.results;

  if (isLoading) return <Loading />;
  if (!results?.length)
    return (
      <>
        {' '}
        <NoRecordFound
          title="No activities Found"
          subTitle={`No activities have been recorded yet.`}
        />
      </>
    );
  return (
    <>
      <Box p={6}>
        {/* Header */}
        <Flex>
          <Text textStyle={'textBody'}>
            Showing{' '}
            <b>
              {Number(auditLogData?.offset ?? 0) + 1} -{' '}
              {Math.min(
                Number(auditLogData?.offset ?? 0) +
                  Number(auditLogData?.limit ?? 0),
                auditLogData?.total ?? 0
              )}
            </b>{' '}
            of <b>{auditLogData?.total}</b> activities
          </Text>{' '}
          <ButtonText
            mb={6}
            ml={3}
            onClick={() =>
              setExpanded(
                expanded.length === (results?.length ?? 0)
                  ? []
                  : results?.map((_, i) => i) ?? []
              )
            }
          >
            {expanded.length === results?.length ? (
              <>
                Collapse All <FontAwesomeIcon icon={faAngleDoubleUp} />
              </>
            ) : (
              <>
                Expand All <FontAwesomeIcon icon={faAngleDoubleDown} />
              </>
            )}
          </ButtonText>
        </Flex>
        <Box>
          {results?.map((step, index) => (
            <TimelineStep
              key={step.id}
              log={step}
              expanded={expanded.includes(index)}
              isLast={index === results?.length - 1}
              onToggle={() => toggleStep(index)}
            ></TimelineStep>
          ))}
        </Box>
      </Box>
      {totalPages > 1 && (
        <Flex justifyContent="center">
          <Pagination
            ariaLabel="Notes pagination"
            currentPage={page}
            totalPages={totalPages}
            onPageChange={setPage}
          />
        </Flex>
      )}
    </>
  );
};

export default AuditLog;
